/**
 * Картинка в буфер обмена, как «Копировать» в Telegram. Браузерный буфер принимает картинки
 * только в PNG, поэтому JPEG, WebP и GIF перерисовываются через canvas (у GIF — первый кадр).
 * Вложения отдаёт наш же сервер (/api/v1/attachments/…), так что fetch и canvas не упираются
 * в CORS.
 */
export async function copyImage(url: string): Promise<void> {
  if (!navigator.clipboard?.write || typeof ClipboardItem === 'undefined') throw new Error('Буфер обмена недоступен в этом браузере')
  const png = (async () => {
    const res = await fetch(url, { credentials: 'same-origin' })
    if (!res.ok) throw new Error(`картинка не загрузилась (${res.status})`)
    const blob = await res.blob()
    if (blob.type === 'image/png') return blob
    const bitmap = await createImageBitmap(blob)
    const canvas = document.createElement('canvas')
    canvas.width = bitmap.width
    canvas.height = bitmap.height
    canvas.getContext('2d')?.drawImage(bitmap, 0, 0)
    bitmap.close()
    return await new Promise<Blob>((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('не удалось подготовить картинку'))), 'image/png'))
  })()
  // промис — прямо в ClipboardItem: Safari разрешает запись, только если её начали в том же нажатии,
  // а загрузка картинки это нажатие иначе «съела» бы
  await navigator.clipboard.write([new ClipboardItem({ 'image/png': png })])
}
